<template>
  <div class="showcase-container">
    <div class="image-card shadow p-3 mb-5">
      <img
        alt="Product Image"
        src="../../../src/assets/logo.png"
        class="image"
      />
    </div>

    <b-card no-body class="description-card shadow p-3 mb-5">
      <b-card-body>
        <b-card-title>Lorem Ipsum dolor sit amet.</b-card-title>

        <b-card-text>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec
          eleifend auctor tempus. Donec nunc quam, blandit non nunc non, lacinia
          luctus felis.
        </b-card-text>

        <b-button pill variant="outline-dark">Shop Now</b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Showcase",
};
</script>

<style scoped lang="scss">
/* ====GENERAL================================================== */
$dark-gray: #d9d9d9;
$light-gray: #e7e7e7;

.showcase-container {
  position: relative;
  height: 580px;
}

.image-card {
  z-index: 1;

  background-color: $dark-gray;
  border-radius: 1.5rem;
  margin-top: 2.5rem;
  display: flex;
  justify-content: center;

  .image {
    height: 100%;
    width: 70%;
    object-fit: cover;
  }
}

.card-body {
  padding: 3rem;
}

.description-card {
  top: -445px;
  left: 640px;
  z-index: 2;
  max-width: 350px;
  max-height: 300px;
  border-radius: 1.5rem;
  border: none;
  text-align: left;
  background-color: $light-gray;

  .card-title {
    font-weight: 700;
    font-size: 28px;
  }

  .card-text {
    font-size: 12px;
    line-height: 1.2;
  }

  button {
    background-color: white;
    border: none;
    font-weight: 700;

    &:hover {
      background-color: black;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1023) {
  .showcase-container {
    margin: 0;
  }
  .image-card {
    max-width: 738px;
  }
}

@media screen and (min-width: 769px) {
  .image-card {
    max-width: 690px;
  }
}

@media screen and (max-width: 768px) {
  .description-card {
    top: 0;
    max-width: 740px;
    max-height: 350px;
  }

  .showcase-container {
    height: auto;
  }
}

@media screen and (min-width: 769px) and (max-width: 992px) {
  .description-card {
    margin-top: 10px;
    margin-left: auto;
  }
}

@media screen and (max-width: 992px) {
  .description-card {
    left: 0;
  }
}
</style>
